import React from 'react';
import PropTypes from 'prop-types';
import { translate as __, sprintf } from 'foremanReact/common/I18n';

const SelectedStatus = ({ selectedCount, totalCount }) => (
  <div className="pf-c-dual-list-selector__status">
    <span className="pf-c-dual-list-selector__status-text">
      {sprintf(__('%(selectedCount)s of %(totalCount)s items selected'), {
        selectedCount,
        totalCount,
      })}
    </span>
  </div>
);

SelectedStatus.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
};

export default SelectedStatus;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/components/DualList/SelectedStatus.js